// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"378":"e60687b3","604":"c3a4ddf1","820":"c6e012de"}[chunkId] + ".js";
};